import { action, extendObservable } from 'mobx';
import pickBy from 'lodash/pickBy';
import FetchService from '../../../core/services/FetchService';
import FormService from '../../../core/services/FormService';
import ConfirmationDialogService from '../../../core/services/ConfirmationDialogService';
import NotificationService from '../../../core/services/NotificationService';

class ModuleCustomizationListService {
  fetch = new FetchService();
  form = new FormService();

  constructor() {
    extendObservable(this, {
      customizations: [],
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
    });
  }

  init = action(() => {
    this.customizations = [];
    this.form.reset();
    this.pagination = {
      ...this.pagination,
      current: 1,
    };
    this.load();
  });

  load = action(() => {
    this.fetch
      .fetch({
        url: '/module-customizations',
        apiVersion: 'v3',
        query: pickBy(
          {
            distributor: this.form.getValue('distributor'),
            page: this.pagination.current,
            size: this.pagination.pageSize,
            expand: 'module.course distributor',
          },
          (x) => !!x
        ),
      })
      .then(() => {
        if (this.fetch.data) {
          this.customizations = this.fetch.data.docs;
          this.pagination = { ...this.pagination, total: this.fetch.data.total };
        } else {
          this.customizations = [];
          this.pagination = { ...this.pagination, total: 0 };
        }
      });
  });

  search = action(() => {
    this.pagination = { ...this.pagination, current: 1 };
    this.load();
  });

  handleChange = action((pagination) => {
    this.pagination = { ...this.pagination, ...pagination };
    this.load();
  });

  handleRemove = action((customization) => {
    ConfirmationDialogService.show(
      'Delete Module Customization',
      'You are about to delete this Module Customization. Do you want to continue?',
      () => {
        this.fetch
          .fetch({
            method: 'delete',
            apiVersion: 'v3',
            url: `/module-customizations/${customization.id}`,
          })
          .then(() => {
            if (this.fetch.data) {
              NotificationService.addNotification('Module Customization deleted successfully.', 'success');
              this.load();
            }
            if (this.fetch.error) {
              NotificationService.addNotification(this.fetch.error, 'error');
            }
          });
      }
    );
  });
}

const moduleCustomizationListService = new ModuleCustomizationListService();

export default moduleCustomizationListService;
